<template>
    <v-dialog v-model="visible" width="700" @keydown.esc="visible = false">
        <v-toolbar dense color="primary">
            <v-toolbar-title>Part: {{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="visible = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card>
            <v-card-text v-html="noteHtml(note)"></v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="visible = false">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'NoteDialog',
  props: {
  },
  data () {
    return {
      visible: false,
      title: null,
      note: null
    }
  },
  methods: {
    show (title, note) {
      this.title = title
      this.note = note
      this.visible = true
    },
    hide () {
      this.visible = false
      this.note = null
    },
    noteHtml (note) {
      if (note) {
        let temp = note.split('|').join('<br>')
        this.$log.debug(temp)
        return temp
      }
    }
  }
}
</script>

<style scoped>

</style>
